import { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AgentLiecenseErrorMsgs } from "@/setting";

import { AccessCode } from "@/setting";


import { Modal, Button, Form } from "react-bootstrap";
import { Row } from "react-bootstrap";
import { Col } from "react-bootstrap";
// import ValidateLicenceModel from "./ValidateLicenceModel";
import InputGroup from 'react-bootstrap/InputGroup';
import {
  getAdditionalInfo,
  verifyLicenseDetails,
  fetchAccessCode,
} from '@/api/AccessCode';

import '/src/components/pdp/style/pdp.css'
import { validateForm } from "@/utils/formValidator";
import { checkDeletedUserEmail } from "@/api/myProfile";
import LoadingText from "@/components/loader/LoadingText.jsx";
import LoadedText from "@/components/loader/LoadedText.jsx";
import UserProfileForm from "@/components/form/UserProfileForm";
import { setLoginCallLocation, setLoginModal, setLoginTab } from "@/redux/login/loginSlice";
import LivevoxChat from "../LivevoxChat";
import { contactAgent } from "@/api/PDP";
import { formatDisplayDate } from "@/utils/dateFormatter";
import { trackApiCall, trackButtonClick } from "@/utils/analytics";
import { globalCmsData } from "@/redux/cms/cmsSelectors";


function AccessCodeModal({
  show,
  userProfileData,
  handleClose,

}) {

  const [errors, setErrors] = useState({});
  const [userData, setUserData] = useState(userProfileData?.userType === "AGENT" ? userProfileData : {});
  const pdpInitData = useSelector((state) => state.pdp.pdpInitData)
  let formRef = useRef();
  const [validated, setValidated] = useState(false);

  const [value, setValue] = useState();
  const [propertyLockBoxInfo, setPropertyLockBoxInfo] = useState();
  const [loader, setLoader] = useState(false);
  const userId = userProfileData?.realbidUserId;
  // const [firstName, setFirstName] = useState(userProfileData?.userDetails?.firstName);
  // const [lastName, setLastName] = useState(userProfileData?.userDetails?.lastName);
  // const [emailId, setEmailId] = useState(userProfileData?.userDetails?.emailId);
  const [licenseNumber, setLicenseNumber] = useState();
  const [licenseExpiryDate, setLicenseExpiryDate] = useState();
  const propertyId = pdpInitData?.propertyDetails?.propertyId;
  const propertySpecialDetails = pdpInitData?.propertySpecialDetails;

  const rowArr = [];
  const [accessCodeStatus, setAccessCodeStatus] = useState();
  const streetNumber = pdpInitData?.propertyDetails?.address?.streetNumber;
  const streetName = pdpInitData?.propertyDetails?.address?.streetName;
  const city = pdpInitData?.propertyDetails.address?.city;
  const stateName = pdpInitData?.propertyDetails.address?.stateName;
  const zip = pdpInitData?.propertyDetails.address?.zip;
  const state = pdpInitData?.propertyDetails.address?.state;
  const [genericError, setGenericError] = useState();
  const [isProccessing, setIsProccesing] = useState(false);
  const [licenseError,setLicenseError] = useState("");
  const [showForm,setShowForm] = useState(false);
  const [realhomeForm,setRealHomeForm] = useState({buyerMessage:`I'd like REALHome Services and Solutions, Inc. to refer me to a local agent to help me purchase the property at ${streetNumber} ${streetName} ${city}, ${state} ${zip}. Thank you.`,buyerLastName:"",buyerFirstName:"",emailId:"",phoneNumber:""});
  const [realhomeSubmitted,setRealHomeSubmitted] = useState(false);
const [realhomeFormErrors, setRealHomeFormErrors] = useState({});
  const globalCms = useSelector(globalCmsData);


  const dispatch = useDispatch();

  const today = new Date().toISOString().split('T')[0]; // Format: YYYY-MM-DD


  const [formData, setFormData] = useState({
    firstName: userProfileData?.userFirstName || "",
    lastName: userProfileData?.userLastName || "",
    propertyState: pdpInitData?.propertyDetails?.address?.state || "",
    licenseNumber: "",
    licenseExpiryDate: "",
    emailId: userProfileData?.userEmailId || '',
  });


  const validationRules = {
    firstName: (value) => {
      if (!value?.trim()) return "This field is required";
      const allowedCharsRegex = /^[a-zA-Z0-9\-._' ]*$/;
      if (value && !allowedCharsRegex.test(value)) {
        return "Characters allowed: a-z A-Z 0-9 and - . ' _";
      }
      return "";
    },
    lastName: (value) => {
      if (!value?.trim()) return "This field is required";
      const allowedCharsRegex = /^[a-zA-Z0-9\-._' ]*$/;
      if (value && !allowedCharsRegex.test(value)) {
        return "Characters allowed: a-z A-Z 0-9 and - . ' _";
      }
      return "";
    },
    emailId: (value) => {
      if (!value) return "This field is required";
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
        return "Please enter a valid email address";
      }
      return "";
    },
    licenseNumber: (value) => {
      if (!value?.trim()) return "This field is required";

      return "";
    },
    licenseExpiryDate: (value) => {
      if (!value) return "This field is required";

      return "";
    },

    propertyState: (value) => {
      if (!value) return "This field is required";
      return "";
    },
    zip: (value) => {
      if (!value) return "This field is required";
      if (!/^\d{5}$/.test(value))
        return "Please enter a valid 5-digit ZIP code";
      return "";
    },

  };

    const validationRules1 = {
    firstName: (value) => {
      if (!value?.trim()) return "This field is required";
      const allowedCharsRegex = /^[a-zA-Z0-9\-._' ]*$/;
      if (value && !allowedCharsRegex.test(value)) {
        return "Characters allowed: a-z A-Z 0-9 and - . ' _";
      }
      return "";
    },
    lastName: (value) => {
      if (!value?.trim()) return "This field is required";
      const allowedCharsRegex = /^[a-zA-Z0-9\-._' ]*$/;
      if (value && !allowedCharsRegex.test(value)) {
        return "Characters allowed: a-z A-Z 0-9 and - . ' _";
      }
      return "";
    },
    emailId: (value) => {
      if (!value) return "This field is required";
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
        return "Please enter a valid email address";
      }
      return "";
    },
    licenseNumber: (value) => {
      if (!value?.trim()) return "This field is required";

      return "";
    },
    licenseExpiryDate: (value) => {
      if (!value) return "This field is required";

  const selectedDate = new Date(value);
  const today = new Date();

  // Clear time portion to ensure accurate date-only comparison
  selectedDate.setHours(0, 0, 0, 0);
  today.setHours(0, 0, 0, 0);

  if (selectedDate < today) {
    return "License expiry date cannot be in the past";
  }
      return "";
    },

    propertyState: (value) => {
      if (!value) return "This field is required";
      return "";
    },


  };


  const handleSubmit = async (event) => {
    // const form = event.currentTarget;
    setLicenseError("")
    event.preventDefault();
    event.stopPropagation();

    trackButtonClick({
      eventName: "access_code_save_click",
      eventCategory: "NEW-PDP",
      eventSource: "on submit click",
      eventLabel: `Property Id:${pdpInitData?.propertyDetails?.propertyId}|Listing Id:${pdpInitData?.propertyDetails?.listingId}`,
    });

    const form = formRef.current;

    const isValid = form?.checkValidity();
 const newErrors = {};

for (const key of Object.keys(validationRules1)) {
  const value = formData[key];
  const validationError = validationRules1[key](value);
  newErrors[key] = validationError;
}
  setErrors(newErrors);

  const hasErrors = Object.values(newErrors).some((value) => value.trim() !== "");



    if (!hasErrors && isValid) {
      setIsProccesing(true);
      setValidated(true);

      const encodedEmail = encodeURIComponent(formData.emailId);
      const queryString = `emailId=${encodedEmail}`;
      const deletedUserCheck = await checkDeletedUserEmail(queryString);
      if (
        deletedUserCheck?.data?.status === "SUCCESS" &&
        deletedUserCheck?.data?.data === true
      ) {
        setIsProccesing(false);
        setGenericError("This email is associated with a deleted account. Please contact support for assistance.");

      } else {
        setLoader(true);
        const body = {
          firstName: formData.firstName,
          lastName: formData.lastName,
          propertyState: pdpInitData?.propertyDetails?.address?.state,
          licenseNumber: formData.licenseNumber,
          licenseExpiryDate: formatDisplayDate(formData.licenseExpiryDate),
          emailId: formData.emailId,
          propertyId: propertyId,
          loggedUserId: userId,
        };
        const showError = true;
        verifyLicense(body, body, showError);
      }

    }

  };


  const getAccessCode = async () => {
    const encodedEmail = encodeURIComponent(formData.emailId);
    const queryString = `emailId=${encodedEmail}`;
    const deletedUserCheck = await checkDeletedUserEmail(queryString);
    if (
      deletedUserCheck?.data?.status === "SUCCESS" &&
      deletedUserCheck?.data?.data === true
    ) {

      setGenericError("This email is associated with a deleted account. Please contact support for assistance.");

    } else {
      setAccessCodeStatus("ERROR");
      setValue("ERROR");
    }

  }


  const verifyLicense = (values, body, showError) => {
    let licenseNum = values?.licenseNumber ? values?.licenseNumber : licenseNumber;
    verifyLicenseDetails(licenseNum, pdpInitData?.propertyDetails?.address?.state)
      .then(res => {
        if ((res.verificationStatus === 'LICENSE_FORMAT_OK') || (res.verificationStatus === "LICENSE_ALREADY_APPROVED")) {
          fetchAccessCode(body)
            .then(response => {

              console.log('response.status', response.status)
              setIsProccesing(false);
              if (response.status === 'FAILURE') {
                trackApiCall({
                  eventName: "access_code_save_not_valid",
                  eventCategory: "NEW-PDP",
                  eventSource: "on submit click",
                  eventLabel: `Property Id:${pdpInitData?.propertyDetails?.propertyId}|Listing Id:${pdpInitData?.propertyDetails?.listingId}|`,
                });
                (false);
                if (showError) {

                  setAccessCodeStatus("ERROR");
                  setValue("ERROR");

                }
              } else if(response.status === "ACCESS_CODE_RESTRICTED_FOR_DOMAIN_STATE") {

                 setAccessCodeStatus("ERROR");
                  setValue("ERROR");
              }
              else{
                trackApiCall({
                  eventName: "access_code_save_valid",
                  eventCategory: "NEW-PDP",
                  eventSource: "on submit click",
                  eventLabel: `Property Id:${pdpInitData?.propertyDetails?.propertyId}|Listing Id:${pdpInitData?.propertyDetails?.listingId}|`,
                });
                if (response?.mainAccessCode) {

                  setValue(response.mainAccessCode);
                  setPropertyLockBoxInfo(response.propertyLockBoxInfo);
                } else {
                  if (showError) {
                    // Alert.alert(en.failed, response.errorMessage);
                  }
                }
              }
            })
            .finally(() => setLoader(false));
        } else {
          setIsProccesing(false);
          setLoader(false);
          if(res.verificationStatus == 'LICENSE_FORMAT_NOT_OK'){
             let agentStateError = AgentLiecenseErrorMsgs[res?.jurisdictName];
                      if (agentStateError !== "No license format information") {
                        setLicenseError(agentStateError);
                        return
                      }
          }
          if (showError) {

            setAccessCodeStatus("ERROR");
            setValue("ERROR");
          }
        }
      })

      .catch(err => console.log('error', err));
  };

  propertyLockBoxInfo?.map((value, index) => {

    const items = [];
    const keys = [];
    Object.entries(value).map(([key, val]) => {

      if (key !== 'unitNumber' && key !== 'id' && key !== 'comments' && key !== 'lockBoxType') {
        items.push(val);
      }

    });
    rowArr.push(items);

  });


  const rows = rowArr;
  const handleInputChange = (event) => {
    const { id, value } = event.target;
console.log(value,'vlaye');

    // Update the form data state
    setFormData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
    // Clear the error for this field when user starts typing
  setErrors((prevErrors) => ({
    ...prevErrors,
    [id]: "",
  }));


    // // Perform validation dynamically using the `validateForm` function
    // const validationErrors = validateForm({ [id]: value }, [id]);

    // // Update the errors state
    // setErrors((prevErrors) => ({
    //   ...prevErrors,
    //   [id]: validationErrors[id] || "",
    // }));

  };

  const handleBlur = (e) => {
    const { id, value } = e.target;

    if (validationRules[id]) {
      const validationError = validationRules[id](value);


      setErrors((prev) => ({
        ...prev,
        [id]: validationError,
      }));


    }
  }

  useEffect(() => {
    if (show) {
      setLoader(true);
      getAdditionalInfo(propertyId)
        .then(data => {
          if (data.status === 'SUCCESS') {

            if (
              data?.agent &&
              data?.agentLicenseDto &&
              data?.agentLicenseDto?.licenseStatus === 'LCNS_APRD' &&
              data?.agentLicenseDto?.stateId === pdpInitData?.propertyDetails?.address?.state &&
              userId
            ) {


              const body = {
                firstName: formData.firstName,
                lastName: formData.lastName,
                propertyState: data.agentLicenseDto.stateId,
                licenseNumber: data.agentLicenseDto.licenceNumber,
                licenseExpiryDate: data.agentLicenseDto.licenceExpiryDate,
                emailId: formData.emailId,
                propertyId: propertyId,
                loggedUserId: userId,
              };
              const values = {
                propertyState: data.agentLicenseDto.stateId,
                licenseNumber: data.agentLicenseDto.licenceNumber,
              };

              verifyLicense(values, body);
            } else {
              setLoader(false);
            }
          } else {
            setLoader(false);
          }
        })
        .catch(err => console.log('error', err));
    }

  }, [show]);



  const getFormatPrice = amount => {
    if (amount?.length === 0 || amount === null || isNaN(amount)) {
      return '';
    }
    return amount?.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
  };

  const handleBuyerRefralForm = async() =>{
     const errors = {};
 Object.entries(realhomeForm).forEach(([name, value]) => {
    const error = validateFieldRealHome(name, value);
    if (error) errors[name] = error;
  });

  if (Object.keys(errors).length > 0) {
    setRealHomeFormErrors(errors);
    return;
  }

    try {
      const payload = {
        ...realhomeForm,propertyId
      }
      const formData = new FormData();

for (const key in payload) {
  if (payload[key] !== undefined && payload[key] !== null) {
    formData.append(key, payload[key]);
  }
}
      const data = await contactAgent(formData);
      if(data?.status==="success"){
        setRealHomeSubmitted(true)
      }else{
        setRealHomeSubmitted(false)
      }
    } catch (error) {

    }
  }

  const handleRealHomeChange = (e) =>{
    const {name,value} = e.target
    setRealHomeForm({...realhomeForm,[name]:value})
  }
  const validateFieldRealHome = (name, value) => {
  switch (name) {
    case 'buyerFirstName':
    case 'buyerLastName':
      if (!value.trim()) return 'This field is required.';
      if (!/^[A-Za-z0-9\s]+$/.test(value)) return 'Only alphabets and spaces are allowed.';
      break;

    case 'emailId':
      if (!value.trim()) return 'Email is required.';
      if (!/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(value))
        return 'Invalid email format.';
      break;

    case 'phoneNumber':
      if (!value.trim()) return 'Phone number is required.';
      if (!/^\d{10}$/.test(value)) return 'Enter a valid 10-digit phone number.';
      break;

    case 'buyerMessage':
      if (!value.trim()) return 'Message is required.';
      if (value.length > 300) return 'Message must be less than 300 characters.';
      break;

    default:
      return '';
  }

  return '';
};
  const handleBlurReal = (e) => {
  const { name, value } = e.target;
  const error = validateFieldRealHome(name, value);
  setRealHomeFormErrors((prev) => ({ ...prev, [name]: error }));
};

  const accessSuccess = () => {

    if (propertyLockBoxInfo?.length > 0) {
      return (

        <div>
          <Row className="p30 row col8"
            style={{
              justifyContent: "space-between",
            }}>
            <Col md={8}>
              <p className="pdpPopupInfoTxt">  {`${streetNumber && streetNumber !== null ? streetNumber : ''} ${streetName && streetName !== null ? streetName : ''
                }`}
                {`${city && city != null ? city : ''}, ${stateName && stateName != null ? stateName : ''
                  } ${zip && zip != null ? zip : ''}`}</p>
            </Col>
            <Col md={4}>
              <p className="pdpPopupInfoTxt">

                MLS ID# <span>{pdpInitData?.propertyDetails?.detailedAttributes.mlsNum}</span>
              </p>
            </Col>

          </Row>
          <div className="p40 pb0">
            <table className="table table-bordered license-table">
              <tr>
                <th style={{ color: 'black' }}>Location</th>
                <th style={{ color: 'black' }}>Gate Code</th>
                <th style={{ color: 'black' }}>Access Code</th>
                <th style={{ color: 'black' }}>Special Instructions</th>
              </tr>
              {propertyLockBoxInfo?.map((item) => {
                return <tr key={item.id}>
                  <td>{item.lockBoxLocation}</td>
                  <td>{item.accessCode}</td>
                  <td>{item.lockBoxCombo}</td>
                  <td>{item.specialInstruction}</td>
                </tr>
              })}
            </table>

          </div>
          {/* <table>
            <th data={columns} />
            <th data={rows} />
          </table> */}

          <div className="p40 pb0">
            <ul className="list-group accessCodeTxt pb30">
              <li>
                {(
                  (propertySpecialDetails.buyerAgentCommissionString !== "" && propertySpecialDetails.buyerAgentCommissionString !== null) ?
                    <div>{propertySpecialDetails.buyerAgentCommissionString}</div>
                    :
                    propertySpecialDetails.buyerAgentCommissionPercent !== "" && propertySpecialDetails.buyerAgentCommissionPercent !== null ?
                      <div>{' \u2022   '} Buyer Agent's Commission: {propertySpecialDetails.buyerAgentCommissionPercent}%
                        of sale price or ${getFormatPrice(propertySpecialDetails.buyerAgentCommissionAmount)}, whichever is higher.
                      </div> : null

                )}           </li>
              <li>
                <span>{' \u2022   '}For assistance with any access issue, please call our Field "Services team while at the property on 1-866-952-6514 (Option 1), Mondays through Fridays 8AM to 9PM EST and 10AM to 7PM EST during weekends and holidays."<span>
                </span></span></li>
              <li >
                <span>{' \u2022   '}For inquiries on buyer agent's commission, please contact the listing agent directly.<span>
                </span></span></li>
            </ul>
          </div>

        </div>
      )

    } else if (accessCodeStatus === "ERROR") {

      return (
        <>
        {
          showForm?<>
          {
            realhomeSubmitted?<>
            <p className="p-4">Thank you. We've sent your message to the agent.</p>
            </>:

            <div id="real-hone-form "className="p30 pt0">
              <img src="/assets/images/pdp/realhome_logo.jpg" className="text-center" alt="Real home" />
              <div>
                <p>Need a referral to a local agent?</p>
                   <div className="container">
                    <label htmlFor="fname">Please enter valid First Name</label>
                    <input type="text" className="form-control w-75" name="buyerFirstName"  onBlur={handleBlurReal} value={realhomeForm?.buyerFirstName} id="fname" onChange={handleRealHomeChange}/>
                    {
                      realhomeFormErrors?.buyerFirstName && <p className="text-danger">{realhomeFormErrors?.buyerFirstName}</p>
                    }
                     <label htmlFor="lname">Please enter valid Last Name</label>
                    <input type="text"  className="form-control w-75"  name="buyerLastName" id="lname" onBlur={handleBlurReal} value={realhomeForm?.buyerLastName} onChange={handleRealHomeChange}/>
                    {
                      realhomeFormErrors?.buyerLastName && <p className="text-danger">{realhomeFormErrors?.buyerLastName}</p>
                    }
                      <label htmlFor="email">Please enter valid Email ID</label>
                    <input type="text"  className="form-control w-75"  name="emailId" id="email"  onBlur={handleBlurReal} value={realhomeForm?.emailId} onChange={handleRealHomeChange}/>
                    {
                      realhomeFormErrors?.emailId && <p className="text-danger">{realhomeFormErrors?.emailId}</p>
                    }
                    <label htmlFor="phoneNumber">Please enter valid Phone Number
</label>
                    <input type="number"  className="form-control w-75"  name="phoneNumber" id="phone"  onBlur={handleBlurReal} value={realhomeForm?.phoneNumber} onChange={handleRealHomeChange}/>
                    {
                      realhomeFormErrors?.phoneNumber && <p className="text-danger">{realhomeFormErrors?.phoneNumber}</p>
                    }
                    <label htmlFor="text-area">Please enter a message
</label>
<textarea name="buyerMessage"  className="form-control w-75"  id="text-area" cols={20} rows={2}  onBlur={handleBlurReal} onChange={handleRealHomeChange} value={realhomeForm?.buyerMessage}></textarea>
                   </div>
                   {
                      realhomeFormErrors?.buyerMessage && <p className="text-danger">{realhomeFormErrors?.buyerMessage}</p>
                    }
                   <button className="btn btn-primary mt-3" onClick={handleBuyerRefralForm}>Request a Referral</button>
              </div>
            </div>
    }
          </>:

          <div id="licenseNotValidMessage " className="p30 pt0">
            <div id="backToAccessCode"><a style={{ color: '#349beb' }} onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setFormData({
                firstName: userData?.userFirstName || formData?.firstName ||"",
                lastName: userData?.userLastName ||formData?.lastName ||"",
                propertyState: pdpInitData?.propertyDetails?.address?.state || "",
                licenseNumber:formData?.licenseNumber ||  "",
                licenseExpiryDate:formData?.licenseExpiryDate ||  "",
                emailId: userData?.userEmailId || formData?.emailId || '',
              });
              setErrors({});
              setAccessCodeStatus(""),
                setValue("")
            }}
              href="">Back to access code form</a></div>
            <p className="text-left pdpPopupInfoTxt pt20 pb10">
              <strong>Agents, please note:</strong>
            </p>
            <ul>
              <li className="accessCodeTxt">You must be licensed in the property's state in order to receive an access code.</li>
              <li className="accessCodeTxt">If we were unable to validate your license information online, we may be able to do so through our Customer Care team.</li>
            </ul>
            <p className="text-left  pdpPopupInfoTxt pt20 pb10">
              <strong>Interested Buyers, please note:</strong>
            </p>
            <ul >
              <li className="accessCodeTxt">To see a property, you'll need the help of a licensed agent. If you're already working with one, please ask your agent to set up a visit. If you don't have an agent, complete this <a style={{ color: '#349beb' }} className="cursor-pointer"   onClick={() => setShowForm(true)} id="openBuyerRefralForm">form</a> and we'll connect you with a local agent who can help.
              </li>
            </ul>
            <p className="text-left  pdpPopupInfoTxt pt20 pb10"><strong>Contact US</strong></p>
            <div className="accessCodeTxt">If you need additional help obtaining an access code or connecting with a local agent:</div>
            <ul >
              <li className="accessCodeTxt">Email us at
                <a style={{ color: '#349beb' }} href="mailto:customercare@hubzu.com"> customercare@hubzu.com</a>
              </li>
              <li className="accessCodeTxt">Call us at
                <a style={{ color: '#349beb' }} href="tel:+18558821314"> (855) 882-1314</a>
              </li>
              <li className="accessCodeTxt">Chat live with us:</li>
            </ul>
                 <div className="d-flex justify-content-start">
                     <LivevoxChat
                              showContent={false}
                              contentTitle={""}
                              contentText={<img src="/assets/images/pdp/offline.png" alt="" />}
                              style={{ color: "#fff",width:"30px",height:"10px"}}
                            />
                <span className="accessCodeTxt pt-2 px-2">LIVE CHAT OFFLINE</span>

                 </div>
            <div id="pdpLiveChat" className="pt20" >
              <div className="contactUs_chat_button" id="liveagent_button_offline">
              </div>
              {/* <div class="contactUs_chat_button online" id="liveagent_button_online"  onclick="liveagent.startChat('')">
      <span>LIVE CHAT ONLINE</span>
    </div> */}
            </div>
            <div className="accessCodeTxtBold">Hubzu Customer Care is available from 7 AM - 7 PM EDT Mon-Fri and 12 PM - 5 PM EDT Sat &amp; Sun</div>
          </div>
    }
        </>
      )
    }

    else {
      return (

           <><div>
          <Row className="p30 row col8"
            style={{
              justifyContent: "space-between",
            }}>
            <Col md={8}>
              <p className="pdpPopupInfoTxt">  {`${streetNumber && streetNumber !== null ? streetNumber : ''} ${streetName && streetName !== null ? streetName : ''}`}
                {`${city && city != null ? city : ''}, ${stateName && stateName != null ? stateName : ''} ${zip && zip != null ? zip : ''}`}</p>
            </Col>
            <Col md={4}>
              <p className="pdpPopupInfoTxt">

                MLS ID# <span>{pdpInitData?.propertyDetails?.detailedAttributes.mlsNum}</span>
              </p>
            </Col>

          </Row>
          <div className="text-center accessCodeVisible p40 pb0">
             <div>
              <p className="getAccessCodeTxt">Access Code</p>
              <p className="accessCode">{value}</p>
            </div>

          </div>
          {/* <table>
      <th data={columns} />
      <th data={rows} />
    </table> */}

          <div className="p40 pb0">
            <ul className="list-group accessCodeTxt pb30">
              <li>
                {(
                  (propertySpecialDetails.buyerAgentCommissionString !== "" && propertySpecialDetails.buyerAgentCommissionString !== null) ?
                    <div>{propertySpecialDetails.buyerAgentCommissionString}</div>
                    :
                    propertySpecialDetails.buyerAgentCommissionPercent !== "" && propertySpecialDetails.buyerAgentCommissionPercent !== null ?
                      <div>{' \u2022   '} Buyer Agent's Commission: {propertySpecialDetails.buyerAgentCommissionPercent}%
                        of sale price or ${getFormatPrice(propertySpecialDetails.buyerAgentCommissionAmount)}, whichever is higher.
                      </div> : null

                )}           </li>
              <li>
                <span>{' \u2022   '}For assistance with any access issue, please call our Field "Services team while at the property on 1-866-952-6514 (Option 1), Mondays through Fridays 8AM to 9PM EST and 10AM to 7PM EST during weekends and holidays."<span>
                </span></span></li>
              <li>
                <span>{' \u2022   '}For inquiries on buyer agent's commission, please contact the listing agent directly.<span>
                </span></span></li>
            </ul>
          </div>

        </div>
        {/* <div>
            <div>
              <p>AccessCode</p>
              <p>{value}</p>
            </div>
            <div>
              {AccessCode.assistence}{' '}
              <p onPress={() => Linking.openURL('tel:18665926514')}>
                {AccessCode.tollfree}
              </p>
              {AccessCode.available}
            </div>
            <div>{AccessCode.anyqueries}</div>
          </div> */}
          </>
      )
    }
  };
  useEffect(()=>{
    setErrors({})
    setLicenseError("")
     setFormData({
                firstName: userProfileData?.userFirstName || "",
                lastName: userProfileData?.userLastName ||"",
                propertyState: pdpInitData?.propertyDetails?.address?.state || "",
                licenseNumber: "",
                licenseExpiryDate:  "",
                emailId: userProfileData?.userEmailId || '',
              });
  },[show,userProfileData,pdpInitData])

  const handleSignIn = () => {

    trackButtonClick({
      eventName: "access_code_sign_in_click",
      eventCategory: "NEW-PDP",
      eventSource: "on Sign In click",
      eventLabel: `Property Id:${pdpInitData?.propertyDetails?.propertyId}|Listing Id:${pdpInitData?.propertyDetails?.listingId}`,
    })

    handleClose();
    dispatch(setLoginModal(true));
    dispatch(setLoginTab("loginTab"));
    dispatch(setLoginCallLocation("Popup"));

  }
const closeModal = () =>{
  setShowForm(false);
  setRealHomeSubmitted(false)
  handleClose()
  // setFormData({})
  setValue()
}

  return (
    <div className="">
      <Modal show={show} size="lg" onHide={closeModal}>
        <Modal.Header closeButton>
          <Modal.Title>
            View Access Code and Buyer Agent Commission Information
          </Modal.Title>
        </Modal.Header>

        {value ? (
          accessSuccess()
        ) : (
          <div>
            <p className="p30 pb0">
              To view the property's access code, please provide the information
              below. Please note that if the Auction has Ended or is Under
              Review, only the selected bidder will be provided an access code
              to tour the property
            </p>
            {(userData === null || userData === undefined || !userId) && (
              <p className="p30 pb0">
                Note: If you already are registered agent, simply
                <a className="link-primary" onClick={() => handleSignIn()}>
                  {" "}
                  Sign In{" "}
                </a>
                first to avoid this step.
              </p>
            )}

            <Modal.Body>
              {licenseError?.length > 0 && (
                <p className="text-danger">{licenseError}</p>
              )}
              <form
                ref={formRef}
                noValidate
                validated={validated}
                onSubmit={handleSubmit}
              >
                <Row className="mb-6 p20">
                  <Form.Group as={Col} md="6">
                    <Form.Control
                      required
                      type="email"
                      placeholder="Email"
                      id="emailId" // Use consistent id to map with validation
                      value={formData.emailId || ""}
                      disabled={userProfileData?.userEmailId ? true : false}
                      onBlur={handleBlur}
                      onChange={handleInputChange}
                      isInvalid={!!errors.emailId} // Show error if validation fails
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.emailId}
                    </Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group as={Col} md="6">
                    <Form.Control
                      required
                      type="text"
                      placeholder="First Name"
                      id="firstName" // Use consistent id to map with validation
                      value={formData.firstName || ""}
                      disabled={userProfileData?.userFirstName ? true : false}
                      onChange={handleInputChange}
                      onBlur={handleBlur}
                      isInvalid={!!errors.firstName} // Show error if validation fails
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.firstName}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Row>

                <Row className="mb-6 p20">
                  <Form.Group as={Col} md="6">
                    <InputGroup hasValidation>
                      <Form.Control
                        type="text"
                        placeholder="Last Name"
                        aria-describedby="inputGroupPrepend"
                        id="lastName" // Use consistent id for validation and state mapping
                        value={formData?.lastName || ""}
                        disabled={userProfileData?.userLastName ? true : false}
                        onChange={handleInputChange}
                        onBlur={handleBlur}
                        required
                        isInvalid={!!errors.lastName} // Dynamically show error state
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.lastName}
                      </Form.Control.Feedback>
                    </InputGroup>
                  </Form.Group>

                  <Form.Group as={Col} md="6">
                    <InputGroup hasValidation>
                      <Form.Control
                        type="text"
                        required
                        id="licenseNumber" // Use consistent id for validation and state mapping
                        placeholder="License Number"
                        aria-describedby="inputGroupPrepend"
                        value={formData.licenseNumber || ""}
                        onBlur={handleBlur}
                        onChange={handleInputChange}
                        isInvalid={!!errors.licenseNumber}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.licenseNumber}
                      </Form.Control.Feedback>
                      {/* <Form.Control.Feedback type="invalid">
                        Please Enter License Number
                      </Form.Control.Feedback> */}
                    </InputGroup>
                  </Form.Group>
                </Row>
                <Row className="mb-6 p20">
                  <Form.Group as={Col} md="6">
                    <Form.Control
                      type="text"
                      placeholder="State"
                      id="propertyState"
                      value={pdpInitData?.propertyDetails?.address?.state}
                      disabled
                    />
                    <Form.Control.Feedback type="invalid">
                      Please provide a valid state.
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group as={Col} md="6">
                    <Form.Control
                      type="date"
                      placeholder="Expiraton Date"
                      min={today}
                      id="licenseExpiryDate"
                      value={formData?.licenseExpiryDate || ""}
                      onChange={(event) => {
                        handleInputChange(event);
                        setLicenseExpiryDate(event.target.value);
                      }}
                      onBlur={handleBlur}
                      isInvalid={!!errors.licenseExpiryDate}
                      required
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.licenseExpiryDate}
                    </Form.Control.Feedback>
                    {/* <Form.Control.Feedback type="invalid">
                      Please valid Expiration date.
                    </Form.Control.Feedback> */}
                  </Form.Group>
                </Row>
                {genericError?.length > 0 && (
                  <p className="error-generic">{genericError}</p>
                )}
                <Form.Group className="mb-8 p20">
                  <p>
                    By clicking on View Access Code, you accept the
                    <a
                      href="/about/terms"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "#349beb", marginLeft: "5px" }}
                      onClick={() => {
                        trackButtonClick({
                          eventName: "access_code_terms_condition_click",
                          eventCategory: "NEW-PDP",
                          eventSource: "on Terms & Condition click",
                          eventLabel: `Property Id:${pdpInitData?.propertyDetails?.propertyId}|Listing Id:${pdpInitData?.propertyDetails?.listingId}`,
                        });
                      }}
                    >
                      Terms & Conditions{" "}
                    </a>
                    and Your
                    <a
                      href={globalCms?.AltiPrivacy}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "#349beb", marginLeft: "5px" }}
                      onClick={() => {
                        trackButtonClick({
                          eventName: "access_code_privacy_rights_click",
                          eventCategory: "NEW-PDP",
                          eventSource: "on Privacy Rights click",
                          eventLabel: `Property Id:${pdpInitData?.propertyDetails?.propertyId}|Listing Id:${pdpInitData?.propertyDetails?.listingId}`,
                        });
                      }}
                    >
                      PRIVACY Rights{" "}
                    </a>
                    of Hubzu.
                  </p>
                </Form.Group>
                <div className="row d-flex justify-content-center align-content-center p40">
                  <button className="btn hubzu-btn-thm center w-30 h50" type="">
                    {isProccessing ? (
                      <LoadingText text="Submit..." />
                    ) : (
                      <LoadedText text="Submit" />
                    )}
                  </button>
                </div>
              </form>
            </Modal.Body>
          </div>
        )}
      </Modal>
    </div>
  );

}

export default AccessCodeModal;
